import React from "react";

const TableOfContents = ({
    items,
    eyebrow = "Agenda / Table of contents",
    title = "Table of contents",
    titleId = "table-of-contents-title",
}) => {
    const scrollToContent = (event, id) => {
        const target = document.getElementById(id);

        if (!target) {
            return;
        }

        event.preventDefault();
        target.scrollIntoView({ behavior: "smooth", block: "start" });
        window.history.replaceState(null, "", `#${id}`);
    };

    if (!items?.length) {
        return null;
    }

    return (
        <nav className="table-of-contents" aria-labelledby={titleId}>
            <div className="table-of-contents__eyebrow">{eyebrow}</div>
            <div className="table-of-contents__box">
                <h2 className="table-of-contents__title" id={titleId}>
                    {title}
                </h2>
                <ol className="table-of-contents__list">
                    {items.map((item, index) => (
                        <li className="table-of-contents__item" key={item.id}>
                            <a
                                className="table-of-contents__link"
                                href={`#${item.id}`}
                                onClick={(event) =>
                                    scrollToContent(event, item.id)
                                }
                            >
                                <span className="table-of-contents__number">
                                    {String(index + 1).padStart(2, "0")}
                                </span>
                                <span className="table-of-contents__label">
                                    {item.label}
                                </span>
                            </a>
                        </li>
                    ))}
                </ol>
            </div>
        </nav>
    );
};

export default TableOfContents;
